import React, { useState } from "react";
import { useFormik } from "formik";
import * as bootstrap from "bootstrap";
import { useDispatch } from "react-redux";
import { FaPencilAlt } from "react-icons/fa";
import {
  EditOrderDetails,
  getSingleOrderView,
} from "../../../../redux/Order/action";

const EditFieldModal = ({
  fieldKey,
  fieldLabel,
  fieldValue,
  id,
  modalId,
  title = "Edit",
  placeholder = "Enter value",
  // Notes can legitimately be cleared; names and addresses cannot.
  required = true,
  // The order screen keeps its record in local state rather than redux, so it
  // has to be told a save happened — dispatching into the store alone updates
  // nothing it reads.
  onSaved,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      [fieldKey]: fieldValue || "",
    },
    validate: (values) => {
      const errors = {};
      if (required && !values[fieldKey]) {
        errors[fieldKey] = `${fieldLabel} is required`;
      }
      return errors;
    },
    onSubmit: async (values) => {
      const payload = { id, [fieldKey]: values[fieldKey] };
      const result = await dispatch(EditOrderDetails(payload, setLoading));

      bootstrap.Modal.getInstance(document.getElementById(modalId))?.hide();
      formik.resetForm();
      if (result?.ok) {
        dispatch(getSingleOrderView(id));
        onSaved?.();
      }
    },
  });

  return (
    <>
      <button
        type="button"
        aria-label={title}
        className="inline-flex items-center justify-center w-7 h-7 rounded-lg text-slate-400 hover:text-blue-600 hover:bg-blue-50 transition-colors"
        data-bs-toggle="modal"
        data-bs-target={`#${modalId}`}
      >
        <FaPencilAlt className="w-3 h-3" />
      </button>

      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby={`${modalId}Label`}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={formik.handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title" id={`${modalId}Label`}>
                  {title}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <label htmlFor="field" className="form-label">
                  {fieldLabel}
                </label>
                <input
                  type="text"
                  id={fieldKey}
                  name={fieldKey}
                  className="form-control"
                  value={formik.values[fieldKey]}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder={placeholder}
                />
                {formik.errors[fieldKey] && (
                  <div className="text-danger mt-2 small text-center">
                    {formik.errors[fieldKey]}
                  </div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditFieldModal;
